import axios from 'axios'
import store from '@/store'
import {Notify, Toast} from 'vant'
import {apiUrl} from '@/config/url'

const config = {
  baseURL: apiUrl,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
    // 'X-Request-Id': Date.now()
    // 'X-Token-Issuer': Vue.ls.get(TOKEN_ISSUER) || '',
    // Authorization: Vue.ls.get(ACCESS_TOKEN) || ''
  },
  responseType: 'json',
  timeout: 180000
}

const request = axios.create(config)

request.interceptors.request.use(
  config => {
    config.headers['X-Request-Id'] = Date.now()
    const token = store.state.account.token
    const tokenIssuer = store.state.account.tokenIssuer
    config.headers['Authorization'] = token || ''
    config.headers['X-Token-Issuer'] = tokenIssuer || ''
    return config
  },
  err => {
    return Promise.reject(err)
  }
)

request.interceptors.response.use(
  response => {
    return response.data
  },
  error => {
    console.log('request error 异常响应------------', error.response)

    // 关闭loading
    Toast.clear()

    if (error.response) {
      let data = error.response.data
      switch (error.response.status) {
        case 403:
          Notify({message: '拒绝访问'})
          break
        case 500:
          if (data.message === 'Token失效，请重新登录') {
            Notify({message: '登录已过期，请重新登录'})
            store.dispatch('user/logout')
          } else {
            Notify({message: '服务器请求错误，请刷新重试或联系管理员'})
          }
          break
        case 404:
          Notify({message: '很抱歉，资源未找到!'})
          break
        case 504:
          Notify({message: '网络超时'})
          break
        case 401:
          Notify({message: '未授权，请重新登录'})
          store.dispatch('logout')
          break
        default:
          Notify({message: data.message || '服务器请求错误，请刷新重试或联系管理员'})
          break
      }
    } else {
      Notify({message: '服务器请求错误，请刷新重试或联系管理员'})
    }
    return Promise.reject(error.response)
  }
)

const ajax = (method = 'get', url = '', data = {}, options = {}) => {
  return new Promise((resolve, reject) => {
    url = `${url}?timestamp=${Date.now()}&sign=sign`
    if (options.queryString) {
      let query = []
      for (let [key, value] of Object.entries(data)) {
        query.push(`${key}=${value}`)
      }
      query.length && (url = `${url}&${query.join('&')}`)
    }
    let hideLoading = options?.hideLoading || false

    if (!hideLoading) {
      Toast.loading({message: '加载中...', forbidClick: true, duration: 0})
    }

    config.baseURL = options.baseURL || apiUrl

    request({
      ...config,
      url,
      method,
      params: method === 'get' ? data : {},
      data: !options.queryString ? (method !== 'get' ? data : {}) : {},
      responseType: options.responseType || 'json',
      headers: {
        ...config.headers,
        ...options.headers
      }
    }).then(res => {
      resolve(res)

      if (!hideLoading) {
        Toast.clear()
      }

      // 错误提示
      if (res.result === 'FAILED') {
        Notify({message: res.errorMessage})
      }
      if (['000029', '000031'].includes(res.errorCode)) {
        // 000029 缺少token, 000031 token无效
        store.dispatch('account/logout')
      }
    })
  })
}

export const get = (url = '', data = {}, options = {}) => {
  return ajax('get', url, data, options)
}

export const post = (url = '', data = {}, options = {}) => {
  return ajax('post', url, data, options)
}

export default request
